import{createStyles as e}from"../../../../../theme/utils/create-styles.js";var t=e({root:{display:"flex",alignItems:"center"},color:{margin:"0px 5px",width:"14px",height:"10.5px",flexShrink:0}});export{t as styles};
